import axios from 'axios';
import Swal from 'sweetalert2';
import draggable from 'vuedraggable';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './MediaListComponent.html';

export default {
  template,

  components: {
    draggable,
  },

  mixins: [CdnMixin],

  props: {
    media: {
      type: Array,
      required: true,
    },
    relatedId: {
      type: Number,
      required: true,
    },
    relatedModel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      mediaFiles: this.media,
      dragging: false,
    };
  },

  methods: {
    deleteImageRelationship(media) {
      Swal.fire({
        title: 'Fjerne bildet fra siden?',
        text: 'Bildet vil ikke bli slettet fra biblioteket.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Ja, fjern!',
        cancelButtonText: 'Avbryt',
      }).then((result) => {
        if (result.value) {
          axios.delete(`/admin/api/v1/media/delete-relation-image/${media.pivot.id}`)
            .then(() => {
              this.mediaFiles = this.mediaFiles.filter(mediaFile => mediaFile.pivot.id !== media.pivot.id);

              Swal.fire('', 'Bildet ble fjernet.', 'success');
            })
            .catch((error) => {
              console.error(error);
              Swal.fire('', 'Det oppstod en feil ved fjerning av media.', 'error');
            });
        }
      });
    },

    updateMediaOrder() {
      axios.post('/admin/api/v1/media/media-order', { items: this.mediaFiles.map(media => media.pivot.id) });
    },
  },
};
